// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../eachYearOfInterval/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var eachYearOfInterval = convertToFP(fn, 1);
export default eachYearOfInterval;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/eachYearOfInterval/index.js
// module id = 856
// module chunks = 0